import {
  REPORT_LOADING,
  REPORT_LOADED,
  REPORT_COMPANIES_LOADED,
  REPORT_COMPANY_SELECTED,
  REPORT_DETAILS_LOADED,
  REPORT_DETAILS_NOTFOUND,
  REPORT_SYNCS_LOADED,
  REPORT_SYNC_SELECTED,
  REPORT_SYNC_DATE_SELECTED
} from '../components/actions/reportsTypes'

const initialState = {
  loading: true,
  exportLoading: false,
  reportCompanyList: null,
  selectedCompany: null,
  reportDetails: null,
  syncsList: null,
  selectedSync: null,
  selectedSyncDate: null
}

const reportsReducer = (state = initialState, action) => {
  switch (action.type) {
    case REPORT_LOADING:
      state.loading = true
      return state
    case REPORT_LOADED:
      state.loading = false
      return state
    case REPORT_COMPANIES_LOADED:
      state.loading = false
      state.reportCompanyList = action.payload
      return state
    case REPORT_COMPANY_SELECTED:
      state.selectedCompany = state.reportCompanyList.find((c) => c.value === action.payload.value)
      return state
    case REPORT_DETAILS_LOADED:
      state.reportDetails = action.payload
      state.loading = false
      return state
    case REPORT_SYNC_DATE_SELECTED:
      state.selectedSyncDate = action.payload
      return state
    case REPORT_SYNC_SELECTED:
      state.selectedSync = action.payload
      return state
    case REPORT_SYNCS_LOADED:
      state.syncsList = action.payload
      return state
    case REPORT_DETAILS_NOTFOUND:
      state.reportDetails = null
      state.loading = false
      return state
    default:
      return state
  }
}

export default reportsReducer
